import cookie from './cookie';
let uinKey = 'qluin';
let fuinKey = 'qluin';
let fuin = ''
export function setUinKey(key){
    uinKey = key;
}
export function setFuinKey(key){
    fuinKey = key;
}
export function setFuin(value){
    fuin = value;
}
/**
 * 获取用户uin
 * @returns {*}
 */
export function getUin() {
    // 业务侧不一定是qluin 所以要允许自定义 比如话费是ia_refill_qluin
    return cookie.get(uinKey) || '';
}

/**
 * 获取用户fuin
 * @returns {*}
 */
 export function getFuin() {
    return fuin || cookie.get(fuinKey) || getUin();
}